const messageCodes = {
	'initiatives' : {
		noSelectionCode : 'common.error.mustSelect.initiative',
		itemDescriptionCode : 'initiatives.initiativeItem',
		cascadeHelpCode : 'report.initiativeReport.cascade.help'
	},
	'scorecards' : {
		noSelectionCode : 'common.error.mustSelect.scorecard-item',
		itemDescriptionCode : 'scorecards.scorecardNode',
		cascadeHelpCode : 'report.customReport.cascade.help'
	}
}

export default messageCodes
messageCodes.__filename__ = 'reports/common/filter/ancestor-filter-message-codes.js'
